/**
 * Een afbeelding die niet meer op zijn pagina past, wordt kleiner zolang hij
 * minstens dit deel van zijn hoogte houdt. Kleiner wordt hij onleesbaar; dan
 * begint hij op de volgende pagina.
 */
export const MIN_IMAGE_FIT_SCALE = 0.55;

export type ImagePageFit =
  | { kind: 'fits' }
  | { kind: 'shrink'; height: number }
  | { kind: 'nextPage' };

/** `height`: hoogte van de afbeelding; `available`: ruimte tot de onderkant van de pagina. */
export function fitImageOnPage(height: number, available: number): ImagePageFit {
  if (height <= available) return { kind: 'fits' };
  if (available >= height * MIN_IMAGE_FIT_SCALE) {
    return { kind: 'shrink', height: Math.floor(available) };
  }
  return { kind: 'nextPage' };
}
